import React from 'react';

import { Field, SelectField } from 'src/components/finalForm';
import { useCurrentUserPermissions } from 'src/hooks/user';

import { DATA_DISPUTE_STATUS_OPTIONS, VERIFICATION_REQUEST_STATUS_OPTIONS } from '../constants';
import { InboxFilterFieldProps, InboxFilterFormFields } from '../types';

export const InboxFilterStatusField: React.FC<InboxFilterFieldProps> = ({ disabled }) => {
  const { hasVerifierRoles } = useCurrentUserPermissions();

  const options = React.useMemo(
    () =>
      hasVerifierRoles
        ? VERIFICATION_REQUEST_STATUS_OPTIONS
        : [...VERIFICATION_REQUEST_STATUS_OPTIONS, ...DATA_DISPUTE_STATUS_OPTIONS],
    [hasVerifierRoles],
  );

  return (
    <Field
      fullWidth
      label="Status (Select all that apply)"
      component={SelectField}
      name={InboxFilterFormFields.statuses}
      options={options}
      multiple
      disabled={disabled}
    />
  );
};
